import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { SUBSCRIBERS_URL } from '../../../config/config';
import Logo from '../../../assests/logo.png';
import './Unsubscribe.css';

const UnsubscribeComponent = () => {
  const [searchParams] = useSearchParams();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const email = searchParams.get('email');

  const handleUnsubscribe = async () => {
    if (!email) {
      toast.error('Email parameter is missing');
      return;
    }

    setIsLoading(true);

    try {
      const response = await fetch(SUBSCRIBERS_URL, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ email })
      });

      const data = await response.json();
      
      if (data.status === 1) {
        toast.success('Successfully unsubscribed from newsletter');
        setTimeout(() => navigate('/'), 2000);
      } else {
        toast.error(data.message || 'Failed to unsubscribe');
      }
    } catch (error) {
      console.error('Unsubscribe error:', error);
      toast.error('Failed to unsubscribe. Please try again later.');
    } finally {
      setIsLoading(false);
    }
  };

  if (!email) {
    return (
      <div className="unsubscribe-wrapper">
        <div className="unsubscribe-container">
          <div className="unsubscribe-content">
            <img src={Logo} alt="Jewelbox Logo" className="unsubscribe-logo" />
            <h1>Invalid Unsubscribe Link</h1>
            <p>This unsubscribe link appears to be invalid or expired.</p>
            <button 
              className="button"
              onClick={() => navigate('/')}
            >
              Return Home
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="unsubscribe-wrapper">
      <div className="unsubscribe-container">
        <div className="unsubscribe-content">
          <img src={Logo} alt="Jewelbox Logo" className="unsubscribe-logo" />
          <h1>Unsubscribe Confirmation</h1>
          <p>We're sorry to see you go! Are you sure you want to unsubscribe from our newsletter?</p>
          <div className="email-display">
            <span>{email}</span>
          </div>
          <div className="unsubscribe-actions">
            <button
              className="button unsubscribe-button"
              onClick={handleUnsubscribe}
              disabled={isLoading}
            >
              {isLoading ? 'Processing...' : 'Confirm Unsubscribe'}
            </button>
            <button
              className="button cancel-button"
              onClick={() => navigate('/')}
              disabled={isLoading}
            >
              Return to Website
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnsubscribeComponent;